/**
 * Whether the "Upgrade to Commission agent" menu item should be rendered.
 *
 * Currently intentionally hidden — flip this to `true` (or restore the
 * upstream metadata gating in MenuHeaderComponent) to bring the entry back.
 */
export const shouldShowUpgradeToCommission = (): boolean => false;
